module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "messageBox"
  }, [_c('div', {
    staticClass: "messageBox-wrap"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.mesBoxTitle.title))]), _vm._v(" "), (_vm.mesBoxType == 1 || _vm.mesBoxType == 5) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v(_vm._s(_vm.mesBoxTitle.subTitle))]), _vm._v(" "), _c('div', {
    staticClass: "itemInput"
  }, [_c('div', {
    staticClass: "font-size-14px",
    staticStyle: {
      "align-self": "center"
    },
    on: {
      "click": function($event) {
        return _vm.selectData(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.pickerValuenew || '请选择时间'))]), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker",
    attrs: {
      "type": "datetime",
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "confirm": _vm.handleConfirm
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.mesBoxType == 2) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("预计处理时间：")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput"
  }, [_c('div', {
    staticClass: "font-size-14px",
    staticStyle: {
      "align-self": "center"
    },
    on: {
      "click": function($event) {
        return _vm.selectData(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.pickerValuenew || '请选择时间'))]), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker",
    attrs: {
      "type": "datetime",
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "confirm": _vm.handleConfirm
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("疑难情况说明：")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.explain),
      expression: "explain"
    }],
    staticClass: "Textarea",
    attrs: {
      "elastic": "",
      "placeholder": "请您输入疑难情况说明",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.explain)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.explain = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.mesBoxType == 3) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("故障原因：")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput dropdownBox"
  }, [_c('div', {
    staticClass: "dropdown font-size-14px",
    class: {
      'color-666': !_vm.dropdownData.value
    },
    attrs: {
      "id": "Dropdown"
    }
  }, [_vm._v(_vm._s(_vm.dropdownData.name))]), _vm._v(" "), _c('img', {
    staticClass: "dropArrow",
    attrs: {
      "src": "static/images/arrow-right.png"
    }
  })])]), _vm._v(" "), (_vm.dropdownData.name == '手动填写') ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("手动填写故障原因：")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sdFillIn),
      expression: "sdFillIn"
    }],
    staticClass: "Textarea",
    attrs: {
      "elastic": "",
      "placeholder": "请输入手动填写内容",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.sdFillIn)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.sdFillIn = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticClass: "Textarea",
    attrs: {
      "elastic": "",
      "placeholder": "请输入备注",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.mesBoxType == 4 || _vm.mesBoxType == 7) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v(_vm._s(_vm.mesBoxTitle.subTitle))]), _vm._v(" "), _c('div', {
    staticClass: "itemInput dropdownBox"
  }, [_c('div', {
    staticClass: "dropdown font-size-14px",
    class: {
      'color-666': !_vm.dropdownData.value
    },
    attrs: {
      "id": "Dropdown"
    }
  }, [_vm._v(_vm._s(_vm.dropdownData.name))]), _vm._v(" "), _c('img', {
    staticClass: "dropArrow",
    attrs: {
      "src": "static/images/arrow-right.png"
    }
  })])]), _vm._v(" "), (_vm.dropdownData.name == '其他') ? _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("其他")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticClass: "Textarea",
    attrs: {
      "elastic": "",
      "placeholder": "请输入其他描述",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.mesBoxType == 6) ? _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("满意度：")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput dropdownBox"
  }, [_c('div', {
    staticClass: "dropdown font-size-14px",
    class: {
      'color-666': !_vm.dropdownData.value
    },
    attrs: {
      "id": "Dropdown"
    }
  }, [_vm._v(_vm._s(_vm.dropdownData.name))]), _vm._v(" "), _c('img', {
    staticClass: "dropArrow",
    attrs: {
      "src": "static/images/arrow-right.png"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_c('div', {
    staticClass: "subTitle"
  }, [_vm._v("意见描述")]), _vm._v(" "), _c('div', {
    staticClass: "itemInput"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remarks),
      expression: "remarks"
    }],
    staticClass: "Textarea",
    attrs: {
      "elastic": "",
      "placeholder": "请输入意见描述",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.remarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remarks = $event.target.value
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footerBtn"
  }, [_c('div', {
    staticClass: "btn bg-appStyle",
    on: {
      "click": function($event) {
        return _vm.onCancel($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('div', {
    staticClass: "btn bg-appStyle",
    on: {
      "click": function($event) {
        return _vm.onSubmit($event)
      }
    }
  }, [_vm._v("提交")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b6b0133"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messagebox.vue
// module id = 859
// module chunks = 1